export const FIELD_TRADING_NAME = 'name';
export const FIELD_ABN = 'abn';
export const FIELD_REGISTERED_NAME = 'entityName';
export const FIELD_IMAGE_PATH = 'imagePath';
